import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input"]

  increment () {
    let value = parseInt(this.inputTarget.value, 10)
    const max = parseInt(this.inputTarget.max, 10)
    if (isNaN(max) || value < max) {
      this.inputTarget.value = value + 1
    }
  }

  decrement () {
    let value = parseInt(this.inputTarget.value, 10)
    const min = parseInt(this.inputTarget.min, 10)
    if (isNaN(min) || value > min) {
      this.inputTarget.value = value - 1
    }
  }
}
